import type { PlatformUser } from '../types'

const implementedRoutes = new Set(['/', '/meu-usuario', '/preferencias', '/seguranca', '/notificacoes', '/sobre', '/equipe', '/contas', '/usuarios', '/assinaturas', '/beta', '/planos', '/trials-retencao', '/auditoria', '/cobrancas', '/recebiveis', '/operacao', '/integracoes', '/atendimento', '/atendimento/novo', '/juridico'])
const implementedDetails = [/^\/atendimento\/[0-9a-f-]+$/i, /^\/cobrancas\/[0-9a-f-]+$/i, /^\/contas\/[0-9a-f-]+$/i, /^\/usuarios\/\d+$/, /^\/assinaturas\/[0-9a-f-]+$/i, /^\/planos\/[0-9a-f-]+$/i]

export function canManageTeam(user: PlatformUser | null) {
  return user?.role === 'administrator' && user.capabilities.includes('team.manage')
}

export function safeImplementedRoute(value?: string | null) {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return null
  const path = value.split('?')[0].split('#')[0]
  return implementedRoutes.has(path) || implementedDetails.some(pattern => pattern.test(path)) ? value : null
}
